// import React from 'react';
export default class Singleton {
  static instance = Singleton.instance || new Singleton();

  currentLanguage = "ar";
  BACKEND_URL = "https://capital-securitization.com:8079/api/v1/";
  // BACKEND_URL = "http://10.10.13.85:8000/api/v1/";

  // API Responses
  storedUserToken = "26deefbc3f399837c24af5ac62c44a8e3add8966";
}
